import { ReactElement } from 'react';

import './style.scss';

interface SectionTitleProps {
  title: string | ReactElement;
}

/**
 * 通用的小标题
 */
export default function SectionTitle(props: SectionTitleProps): JSX.Element {
  const { title } = props;
  return <h2 className="section-title">{title}</h2>;
}
